import { render, staticRenderFns } from "./metricLabels.vue?vue&type=template&id=43d58c26"
import script from "./metricLabels.vue?vue&type=script&lang=js"
export * from "./metricLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports